<template>
  <DoctorDashboardCard v-if="data.show">
    <template v-slot:title>
      <h3>
        <v-icon class="primary--text pr-2">campaign</v-icon>
        Envoyer une annonce
      </h3>
    </template>
    <template v-slot:text>
      <v-text-field v-model="announcement.title"
                    outlined
                    label="Titre"
                    :error-messages="errors.title"></v-text-field>
      <!--v-textarea v-model="announcement.body"
                  outlined
                  label="Message"
                  :error-messages="errors.body"></v-textarea-->
      <v-text-field v-model="link"
                    outlined
                    label="Lien du tchat"></v-text-field>
      <v-select v-model="announcement.selectedTag"
                :items="availableTags"
                label="Groupes"
                outlined
                :error-messages="errors.selectedTag"></v-select>
      <div class="d-flex justify-space-between">
        <v-text-field v-model="announcement.date_end"
                      class="pr-5"
                      outlined
                      label="Date de tchat"
                      :error-messages="errors.date_end"
                      type="date"></v-text-field>
        <v-text-field v-model="announcement.time_end"
                      class="pl-5"
                      outlined
                      label="Heure de tchat"
                      :error-messages="errors.time_end"
                      type="time"></v-text-field>
      </div>
      <v-btn class="primary"
             block
             :disabled="link === null"
             @click="submit"
             :loading="loading">Envoyer
      </v-btn>
    </template>
    <template v-slot:info-text>
      Envoyer une annonce aux clients
    </template>
  </DoctorDashboardCard>
</template>

<script>
import api from 'api'
import DoctorDashboardCard from 'components/Iriade/DoctorDashboardCard'
import moment from 'moment'

export default {
  components: {DoctorDashboardCard},

  computed: {
    availableTags () {
      return [
        {
          text: `Tous les ${this.$application.labels.patients}`,
          value: 'all'
        },
        ...this.patientsTags.map(t => ({
          text: t.label,
          value: t.id
        }))
      ]
    },

    body () {
      let mom_date = this.announcement.date_end + 'T' + this.announcement.time_end;

      let a = document.createElement('a');
      a.appendChild(document.createTextNode(this.link));
      a.title = this.link;
      a.href = (this.link.match(/^http(?:s*):\/\//g)) ? this.link : "http://" + this.link;
      a.target = "_blank";
      return this.data.body[0] + moment(mom_date).format('dddd LL') + " de " + moment(mom_date).format('LT') + ' à ' + moment(mom_date).add(moment.duration(30, 'minute')).format('LT') + this.data.body[1] + a.outerHTML;
    },
  },

  data: () => ({
    announcement: {
      title: null,
      body: null,
      selectedTag: null,
      date_end: null,
      time_end: null,
      type: null,
    },

    link: null,

    data: {
      //show: false,
    },

    momTest: null,

    errors: {},

    patientsTags: [],

    loading: true,
  }),

  methods: {
    submit () {
      this.announcement.body = this.body;

      api.post(`d/announcements`, this.announcement)
        .then(_ => {
          api.post('salutance/dispatchAppointment', this.announcement)
            .then(_ => {
              this.$router.push({name: 'announcements@index'});
            })
            .catch(err => {
              this.errors = err.response.data.errors;
            })
        })
        .catch(err => {
          this.errors = err.response.data.errors;
        })
        .then(_ => {

        })
    },
    mom(arg1, arg2) {
      return moment(arg1, arg2);
    }
  },

  mounted () {
    this.momTest = moment;

    api.get('d/patientsTags')
      .then(res => {
        this.patientsTags = res.data
      });

    api.get(`dashboard/modules/find`, {params: {class_name: this.module.class_name}})
      .then(res => {
        this.loading = false;
        this.data = res.data;
        this.announcement.title = res.data.title;
        //this.announcement.body = res.data.body;
        this.announcement.selectedTag = res.data.group;
        this.announcement.date_end = res.data.date;
        this.announcement.time_end = res.data.hour;
        this.announcement.type = res.data.type;
        this.link = res.data.link;
      });
  },

  props: ['module']
}
</script>
